export default "__VITE_ASSET__10a0b29c__"